<template>
  <div id="profile-compos">
    <div
      :style="screenWidth>=1200?'height: '+screenHeight*0.8+'px;':'auto;'"
      class="whitedark-bg pl-0 pr profile-img">
      <div
        class="wi-100x ht-100x centerimage pr"
        :style="{backgroundImage: 'url(' + infoObj.img + ')'}">
        <div ref="backImage" class="ht-100x wi-0 white-bg pa"></div>
        <div class="wi-100x ht-100x transition-slow pa tp-0 lf-0 whitedark-bg" v-observe-visibility="imageVisible"></div>
      </div>
    </div>
    <div class="wrapper profile-content"  v-observe-visibility="textVisible">
      <div :class="screenWidth<768 ? 'pl-20 pr-20':''">
        <el-row>
          <el-col :span="12" :xs="24" :sm="24" :md="12">
            <div ref="serviceTitle" class="serif transition-gentle op-0 pr bm--50 profile-subtitle black">{{infoObj.subtitle}}</div>
            <div v-show="screenWidth>=1200" ref="serviceHint" class="tt-u op-0 fs-14 transition-gentle black what-we-do-text">Our Service</div>
            <div v-show="screenWidth>=1200" ref="serviceLine" class="what-we-do-line transition-lenear"></div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="op-0">xx</div>
          </el-col>
          <el-col :span="12" :lg="12" :md="20" :sm="20" :xs="24">
            <div ref="serviceIntro1" class="profile-content1 lh-30 transition-slow op-0 pr rt--60">{{infoObj.content1}}</div>
            <div ref="serviceIntro2" class="profile-content2 lh-30 transition-slow op-0 pr rt--60">{{infoObj.content2}}</div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: ['info'],
  name: 'Profile',
  computed: {
    ...mapGetters([
      'scrollTop',
      'screenHeight',
      'screenWidth',
      'serviceInfo'
    ])
  },
  data () {
    return {
      infoObj: {}
    }
  },
  watch: {
    serviceInfo (val) {
      // 如果有传入值, 则返回, 否则显示服务中的数据
      if (this.info === '' || this.info === undefined || this.info === {} || this.$.o2s(this.info) === '{}') {
        // 如果缓存有数据就在缓存取
        if (this.$.g('serviceInfo')) {
          this.infoObj = this.$.s2o(this.$.g('serviceInfo'))
        } else {
          this.infoObj = this.$.s2o(this.serviceInfo)
          this.$.s('serviceInfo', this.serviceInfo)
        }
      } else {
        this.infoObj.img = this.info.work_banner
        this.infoObj.subtitle = this.info.work_title
        this.infoObj.content1 = this.info.work_background
        this.infoObj.content2 = this.info.work_intro
      }
    },
    scrollTop (val) {
      this.setImageWidth()
    },
    info () {
      // 如果有传入值, 则返回, 否则显示服务中的数据
      if (this.info === '' || this.info === undefined || this.info === {} || this.$.o2s(this.info) === '{}') {
        // 如果缓存有数据就在缓存取
        if (this.$.g('serviceInfo')) {
          this.infoObj = this.$.s2o(this.$.g('serviceInfo'))
        } else {
          this.infoObj = this.$.s2o(this.serviceInfo)
          this.$.s('serviceInfo', this.serviceInfo)
        }
      } else {
        this.infoObj.img = this.info.work_banner
        this.infoObj.subtitle = this.info.work_title
        this.infoObj.content1 = this.info.work_background
        this.infoObj.content2 = this.info.work_intro
      }
    }
  },
  mounted () {
    // 如果有传入值, 则返回, 否则显示服务中的数据
    if (this.info === '' || this.info === undefined || this.info === {} || this.$.o2s(this.info) === '{}') {
      // 如果缓存有数据就在缓存取
      if (this.$.g('serviceInfo')) {
        this.infoObj = this.$.s2o(this.$.g('serviceInfo'))
      } else {
        this.infoObj = this.$.s2o(this.serviceInfo)
        this.$.s('serviceInfo', this.serviceInfo)
      }
    } else {
      this.infoObj.img = this.info.work_banner
      this.infoObj.subtitle = this.info.work_title
      this.infoObj.content1 = this.info.work_background
      this.infoObj.content2 = this.info.work_intro
    }
  },
  methods: {
    setImageWidth () {
      let moveSpeed = this.scrollTop / 3
      let e = this.$refs.backImage
      let paddingWidth = 0
      if (this.screenWidth < 1500) {
        paddingWidth = (this.screenWidth - 1080) / 2
      } else {
        paddingWidth = (this.screenWidth - 1200) / 2
      }
      if (this.scrollTop < 10) {
        e.style.width = '0'
        e.style.backgroundColor = '#F9F9FA'
      } else if (this.scrollTop > 10 && this.scrollTop < 2000) {
        if (moveSpeed < paddingWidth) {
          e.style.width = moveSpeed + 'px'
        }
        e.style.backgroundColor = '#ffffff'
      }
    },
    /**
     * 文本内容
    */
    textVisible (isVisible, entity) {
      if (isVisible) {
        setTimeout(() => {
          this.$refs.serviceTitle.style.opacity = 1
          this.$refs.serviceTitle.style.bottom = 0
        }, 500)
        setTimeout(() => {
          this.$refs.serviceIntro1.style.opacity = 1
          this.$refs.serviceIntro1.style.right = 0
        }, 1000)
        setTimeout(() => {
          this.$refs.serviceIntro2.style.opacity = 1
          this.$refs.serviceIntro2.style.right = 0
        }, 1300)
        setTimeout(() => {
          this.$refs.serviceHint.style.opacity = 1
          this.$refs.serviceLine.style.width = '50%'
        }, 2000)
      }
    },
    /**
     * 背景图片
    */
    imageVisible (isVisible, entity) {
      if (isVisible) {
        entity.target.style.height = 0
      }
    }
  }
}
</script>

<style>
.what-we-do-text {
  letter-spacing: 8px;
  position: relative;
  top: 355px;
}
.what-we-do-line {
  display: block;
  width: 0%;
  height: 1px;
  background-color: #1f1e1d;
  position: relative;
  top: 348px;
  left: 200px;
}
.profile-content {
  padding-top: 50px;
}
.profile-subtitle {
  font-size: 2.4em;
  font-weight: 500;
  margin-bottom: 20px;
}
.profile-content1, .profile-content2, .article-paragraph {
  color: #333333;
  font-size: 16px;
  line-height: 28px;
  margin-bottom: 30px;
}
.profile-content2 {
  margin-bottom: 80px;
}
.profile-content1 {
  margin-bottom: 40px;
}
.profile-img {
  height: 300px;
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  .profile-content {
    padding-top: 120px;
  }
  .profile-subtitle {
    font-size: 52px;
  }
  .profile-content1, .profile-content2 {
    font-size: 17px;
  }
  .profile-content1 {
    margin-bottom: 60px;
  }
  .profile-content2 {
    margin-bottom: 100px;
  }
  .profile-img {
    height: 500px;
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .profile-content {
    padding-top: 120px;
    padding-bottom: 20px;
  }
  .profile-subtitle {
    font-size: 60px;
  }
  .profile-content1, .profile-content2 {
    font-size: 17px;
  }
  .profile-content1 {
    margin-bottom: 60px;
  }
  .profile-content2 {
    margin-bottom: 100px;
  }
  .profile-img {
    height: 700px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .profile-content {
    padding-top: 120px;
    padding-bottom: 40px;
  }
  .profile-subtitle {
    font-size: 66px;
  }
  .profile-content1, .profile-content2, .article-paragraph {
    font-size: 14px;
    line-height: 26px;
  }
  .profile-content1 {
    font-size: 14px;
    margin-bottom: 60px;
  }
  .profile-content2 {
    font-size: 14px;
    margin-bottom: 80px;
  }
  .what-we-do-text {
    top: 315px;
  }
  .what-we-do-line {
    top: 308px;
  }
  .profile-img {
    height: 800px;
  }
}
@media screen and (min-width: 1920px) {
  .profile-content {
    padding-top: 120px;
    padding-bottom: 40px;
  }
  .profile-subtitle {
    font-size: 76px;
  }
  .profile-content1, .profile-content2, .article-paragraph {
    font-size: 16px;
    line-height: 30px;
  }
  .profile-content1 {
    margin-bottom: 60px;
  }
  .profile-content2 {
    margin-bottom: 100px;
  }
  .profile-img {
    height: 800px;
  }
}
</style>



// WEBPACK FOOTER //
// src/compos/Profile.vue